<template>
  <div class="launch">
    <van-nav-bar>
      <div slot="left" @click="close">
        <van-icon name="arrow-left" color="#333" size="19" />
      </div>
      <div slot="title">发起公文</div>
    </van-nav-bar>
    <div class="pep-list">
      <div class="launch-wrap">
        <van-field required v-model="docTitle" label="公文主题" placeholder="请输入公文主题" maxlength="80" />
        <van-field required name="radio" label="公文等级">
          <template #input>
            <van-radio-group v-model="SeverityLevel" direction="horizontal">
              <van-radio :name="2">紧急</van-radio>
              <van-radio :name="1">普通</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          required
          readonly
          clickable
          name="picker"
          :value="docTypeObj.text"
          label="公文种类"
          placeholder="点击选择公文种类"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            round
            position="bottom"
            :columns="docTypeList"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field v-model="government" label="发文机关" placeholder="请输入发文机关" maxlength="20" />
        <van-field v-model="IssuedNum" label="发文字号" placeholder="请输入发文字号" maxlength="50" />
        <van-field
          v-model="textarea"
          rows="3"
          autosize
          label="说明事项"
          type="textarea"
          maxlength="300"
          placeholder="请输入说明事项"
          show-word-limit
        />
      </div>
      <div class="launch-wrap">
        <van-cell title="发文内容" value-class='colors' />
        <div class="enclosure">
          <div style="display:flex;align-items:center;">
            <div class="pr add-files">
              <input 
                id="fileAll" 
                ref="fileAll" 
                type="file" 
                multiple="multiple" 
                @change="changeFunc($event)" 
                class="pa cursor-p" 
                style="top:0;left:0;width:100%;height:100%;opacity:0;z-index:1;" />
                <div class="add-files-icon"><van-icon name="plus" /></div>
                <div class="add-files-text">添加附件</div>
            </div>
            <div class="tips">附件最大可上传：100MB。</div>
          </div>
          <template v-for="(item,index) of filesList">
            <div :key="index" class="files-flex" ref="filesDom">
              <div class="files-flex-text nowrap">
                <i class="iconfont iconimg" v-if="item.type.indexOf('image')>-1">&#xe705;</i>
                <i class="iconfont icontext" v-else>&#xe706;</i>
                <span>{{item.name}}</span>
              </div>
              <van-icon name="clear" color="#F5222D" size="22" @click="delFiles(index)" />
            </div>
          </template>
        </div>
      </div>
      <div class="launch-wrap">
        <van-cell 
        required
          title="人员" 
          is-link
          value="更多" 
          value-class='colors'
          @click="isView=true" />
          <!-- :value="'详情'+'(共'+addPepList.length+'人)'"  -->
        <div class="launch-wrap-flex">
          <div @click="addPepBtn" class="launch-wrap-add">
            <van-icon name="plus" color="#979B9E" size="18" />
          </div>
          <template v-for="(item,index) in addPepList">
            <div v-if="index<5" :key="item.UserID" class="launch-wrap-flex-w">
              <div v-if="item.Icon===''" class="launch-wrap-list pr">
                {{xy.showName(item.FullName)}}
                <van-icon name="clear" @click="delPep(index)" />
              </div>
              <div v-else class="launch-wrap-list pr">
                <img :src="xyMApi+'/base'+item.Icon" alt="">
                <van-icon name="clear" @click="delPep(index)" />
              </div>
              <span class="nowrap">{{item.FullName}}</span>
            </div>
          </template>
        </div>
        <van-popup
          v-model="isView"
          position="right"
          :style="{ height: '100%', width: '100%', background: '#f5f5f5' }"
        >
          <van-nav-bar fixed>
            <div slot="title">人员详情</div>
            <div slot="right" @click="isView=false" style="color:#4196ff">确定</div>
          </van-nav-bar>
          <div class="launch-detail">                
            <template v-for="(item,index) in addPepList">
              <div :key="item.UserID" class="launch-detail-list van-hairline--bottom">
                <div class="launch-detail-list-flex">
                  <div class="launch-detail-list-icon">
                    <span v-if="item.Icon===''">{{xy.showName(item.FullName)}}</span>                    
                    <img v-else :src="xyMApi+'/base'+item.Icon" alt="">
                  </div>
                  <div class="launch-detail-list-clounm">
                    <span class="nowrap">{{item.FullName}}</span>
                    <span class="nowrap">{{item.UserName}}</span>
                  </div>
                </div>
                <div @click="delPep(index)" class="launch-detail-list-del">移除</div>
              </div>              
            </template>
          </div>
        </van-popup>
      </div>
      <AddPep :isShowPep="isShowPep" :addPepList="addPepList" @listenToChildClose="closeAddPep" @listenToChildChoice="getPepList"/>
    </div>
    <div class="search-footer van-hairline--top">
      <div class="cancel" @click="close">取消</div>
      <div class="submit" @click="publishDoc">提交</div>
    </div>
  </div>
</template>
<script>
import AddPep from './AddPep'
export default {
  name:'Launch',
  components:{
    AddPep
  },
  data(){
    return{
      isView:false,
      showPicker:false,
      docTypeObj:{
        text:null,
        id:-1
      },
      SeverityLevel: 1,
      docTypeList:[],
      docTitle:'',
      government: '',
      IssuedNum: '',
      textarea: '',
      totalMB: 0,
      filesList: [],
      isShowPep:false,
      teaList:[],
      addPepList:[],
      docTypes: ['rar', 'zip', 'PNG', 'JPG', 'JPEG', 'GIF', 'SVG', 'DOC', 'DOCX', 'DOTX', 'DOT', 'PDF', 'TXT', 'XML', 'PPT', 'PPTX', 'XLS', 'XLSX', 'XLST', 'png', 'jpg', 'jpeg', 'gif', 'svg', 'doc', 'docx', 'dotx', 'dot', 'pdf', 'txt', 'xml', 'ppt', 'pptx', 'xls', 'xlsx', 'xlst']
    }
  },
  created(){
    this.getListData()
  },
  methods:{
    close(){
      this.$router.go(-1)
    },
    async getListData () { // 获取公文类型
      this.xy.loading()
      this.docTypeList=[]
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/OfficialDocCirculationType/GetAll`)
      if (res.success) {
        res.data.map(item=>{
          this.docTypeList.push({
            text:item.Name,
            id:item.ID
          })
        })
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    onConfirm(val){
      this.showPicker = false
      this.docTypeObj=val
    },
    changeFunc (e) {
      for (var i = 0; i < e.target.files.length; i++) {
        let splitType = e.target.files[i].name.split('.')
        if (this.docTypes.indexOf(splitType[splitType.length - 1]) < 0) {
          this.xy.alert('文件格式错误，仅支持以下格式：\n\njpeg，png，jpg，svg，gif，doc，docx，\n\ndotx，dot，pdf，txt，xml，ppt，pptx，\n\nxls，xlsx，xlst，rar，zip')
          return
        }
      }
      this.totalMB = 0
      this.filesList = [...this.filesList, ...e.target.files]
      for (let i = 0, len = this.filesList.length; i < len; i++) {
        if (this.filesList[i].isDel === undefined || !this.filesList[i].isDel) {
          this.$set(this.filesList[i], 'isDel', false)
          this.totalMB += this.filesList[i].size / 1024 / 1024
        }
      }
    },
    delFiles (itemIndex) {
      this.$set(this.filesList[itemIndex], 'isDel', true)
      let isDelLen = this.filesList.filter(item => {
        return !item.isDel
      })
      this.filesList = isDelLen
      this.totalMB = 0
      for (let i = 0, len = this.filesList.length; i < len; i++) {
        if (!this.filesList[i].isDel) {
          this.totalMB += this.filesList[i].size / 1024 / 1024
        }
      }
      if (isDelLen.length === 0) {
        this.$refs.fileAll.value = null
      }
    },
    async addPepBtn(){
      this.isShowPep=true
    },
    closeAddPep(val){
      this.isShowPep=val
    },
    getPepList(list){
      this.isShowPep=false
      this.addPepList=list
    },
    delPep(i){
      this.addPepList.splice(i,1)
    },
    publishDoc(){
      if(!this.docTitle){
        this.xy.msgError('公文主题不能为空')
        return
      }
      if(this.docTypeObj.id===-1){
        this.xy.msgError('公文种类不能为空')
        return
      }
      // if(!this.government){
      //   this.xy.msgError('发文机关不能为空')
      //   return
      // }
      // if(!this.IssuedNum){
      //   this.xy.msgError('发文字号不能为空')
      //   return
      // }
      // if(!this.filesList.length){
      //   this.xy.msgError('文件内容不能为空')
      //   return
      // }
      if (this.totalMB > 100) {
        this.xy.msgError('附件总大小不能超过100M')
        return
      }
      if(!this.addPepList.length){
        this.xy.msgError('人员不能为空')
        return
      }
      // 执行上传和提交操作
      if (this.totalMB) {
        this.upLoadFile()
      } else {
        this.submitFunc()
      }
    },
    async upLoadFile () { // 上传
        this.xy.loading()
        let formData = new FormData()
        for (let i = 0, len = this.filesList.length; i < len; i++) {
          formData.append('file', this.filesList[i])
        }
        let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/OfficialDocCirculationDoc/Upload`, formData, true)
        if (res.success) {
          this.submitFunc(res.data)
        } else {
          this.xy.msgError(res.msg)
          this.xy.unloading()
        }
      },
      async submitFunc (returnFilesData) { // 提交
        let pepList = []
        this.addPepList.map(item => {
          pepList.push(item.UserID)
        })
        let option = {
          Title: this.docTitle, // 公文主题
          TypeID: this.docTypeObj.id, // 公文种类
          DocumentAgency: this.government, // 发文机关
          DocumentNumber: this.IssuedNum, // 发文字号
          Note: this.textarea, // 说明事项
          DocFileList: returnFilesData && returnFilesData.DocFileList ? returnFilesData.DocFileList : [], // 附件集合
          DocUsers: pepList,// 人员集合
          SeverityLevel: this.SeverityLevel // 公文等级
        }
        let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/OfficialDocCirculationDoc/Create`, option, true)
        if (res.success) {
          this.xy.msgSuc('公文流转发起成功')
          this.close()
        } else {
          this.xy.msgError(res.msg)
        }
        this.xy.unloading()
      },
  }
}
</script>
<style lang="less" scoped>
.launch-detail{
  margin-top:110px !important;
  background: #fff;
  .launch-detail-list{
    height:100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left:30px;
    padding-right:30px;
    .launch-detail-list-flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right:30px;
      .launch-detail-list-icon{
        display: flex;
        justify-content: center;
        align-items: center;
        width:76px;
        height:76px;
        border-radius:50%;
        background:#2980FE;
        color: #fff;
        margin-right:30px;
        img{
          width: 76px;
          height:76px;
          border-radius:50%;
        }
      }
      .launch-detail-list-clounm{
        display: flex;
        flex-flow: column;
        width: 460px;
        span:nth-child(2){
          font-size: 28px;
          color:rgba(0,0,0,.45);
          margin-top:5px;
        }
      }
    }
    .launch-detail-list-del{
      color:#F87C7C;
      font-size: 30px;
    }
  }
}
.launch{
  display: flex;
  flex-flow: column;
  height:100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  right: 0;
  .pep-list{
    height: calc(100% - 220px);
    overflow-y: auto;
  }
  .search-footer{
    position: fixed;
    bottom:0;
    left:0;
    right: 0;
    display: flex;
    justify-content: space-between;
    padding:20px;
    background: #fff;
    div{
      width:346px;
      height:88px;
      border-radius: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:30px;
    }
    .cancel{
      color:#267DFF;
      background:rgba(255,255,255,1);
      border:1px solid rgba(38,125,255,1);
    }
    .submit{
      color:#fff;
      background:rgba(41,128,254,1);
    }
  }
  .launch-wrap{
    margin-top: 20px;
    .launch-wrap-flex{
      display: flex;
      flex-wrap: wrap;
      background: #fff;
      min-height: 160px;
      padding:30px 0 30px 30px;
      .launch-wrap-flex-w{
        display: flex;
        flex-flow: column;
        .launch-wrap-list{
          display: flex;
          justify-content: center;
          align-items: center;
          width:88px;
          height:88px;
          margin:0 30px 10px 0;
          border-radius:50%;
          background:#2980FE;
          color: #fff;
          i{
            position: absolute;
            right:-8px;
            top:-8px;
            color:#F87C7C;
            font-size: 32px;
          }
          img{
            width: 88px;
            height:88px;
            border-radius:50%;
          }
        }
        span{
          width:88px;
          margin-right:30px;
          text-align: center;
        }
      }
      .launch-wrap-add{
        display: flex;
        justify-content: center;
        align-items: center;
        width:88px;
        height:88px;
        background:rgba(250,250,250,1);
        border:1px solid rgba(230,230,230,1);
        border-radius:50%;
        margin:0 30px 30px 0;
      }
    }
    .enclosure{
      background: #fff;
      padding:20px 30px;
      min-height: 100px;
      .add-files{
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        width:140px;
        height:180px;
        background:rgba(250,250,250,1);
        border:1px solid rgba(230,230,230,1);
        border-radius:10px 10px 22px 10px;
        .add-files-icon{
          color:#979B9E;
          margin-bottom: 10px;
          i{
            font-size:40px;
          }
        }
        .add-files-text{
          color:rgba(0,0,0,.85);
        }
      }
    }
    .colors{
      color:#2980FE;
    }
    .tips{
      color:#9f9f9f;
      padding:20px 30px;
      background: #fff;
    }
    .files-flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:30px 0;
      border-radius: 4px;
      cursor: pointer;
      .files-flex-text{
        flex: 1;
        margin-right: 40px;
        i{
          margin-right:5px;
          font-size: 32px;
        }
        .icontext{
          color:#4196FF;
          font-size: 32px;
          margin-right:10px;
        }
        .iconimg{
          color:#F1C64E;
          font-size: 32px;
          margin-right:10px;
        }
      }
    }
  }
}
</style>
